import { render, staticRenderFns } from "./PartnerEmailSettings.vue?vue&type=template&id=178f2ee2&scoped=true&"
import script from "./PartnerEmailSettings.vue?vue&type=script&lang=js&"
export * from "./PartnerEmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f2ee2",
  null
  
)

export default component.exports